<!-- @format -->

<div data-cy="editable-attainment-tree-grouping-module-row" class="row editable-attainment-tree-group-node-row">
  <div class="col-12 name" [class.removed-grouping-module]="moduleSelection.hidden">
    @if (moduleSelection.hidden) {
      <span data-cy="tree-node-name" class="grouping-node-name">{{ moduleSelection.newName | localizedString }}</span>
      <sis-button (clicked)="unRemove()" [link]="true" data-cy="show-grouping-module">
        <sis-icon icon="back"></sis-icon>
        <span translate>ATTAINMENTS.EDITABLE_ATTAINMENT_TREE.SHOW_GROUPING_MODULE</span>
      </sis-button>
    }
    @if (!moduleSelection.hidden) {
      <button
        type="button"
        class="non-button"
        (click)="collapsedByGroupingModuleId[moduleSelection.moduleId] = !collapsedByGroupingModuleId[moduleSelection.moduleId]"
        [attr.aria-expanded]="!collapsedByGroupingModuleId[moduleSelection.moduleId]"
        [attr.aria-label]="moduleSelection.newName | localizedString">
        <sis-icon icon="chevron" [iconClass]="collapsedByGroupingModuleId[moduleSelection.moduleId] ? null : 'cw-90'"></sis-icon>
      </button>
      <span>{{ moduleSelection.newName | localizedStringWithoutFallback: privateSelectedLocale }}</span>
      @if (!nameIsOriginal) {
        <sis-tooltip
          [tooltipText]="originalNameTextForTooltip"
          [tooltipClass]="'line-breaks tooltip-wide'"
          class="with-language-pills"
          [tooltipBlockElement]="true">
          <span class="sis-tooltip-trigger-content">
            <sis-icon icon="info-circle" color="primary"></sis-icon>
          </span>
        </sis-tooltip>
      }
      <sis-localized-string class="grouping-node-name" [data]="moduleSelection.newName" [(selectedLocale)]="privateSelectedLocale">
      </sis-localized-string>
      @if (!nameEditMode) {
        <button (click)="editName()" type="button" class="link-button" data-cy="edit-group-node-name">
          <span translate>ATTAINMENTS.EDITABLE_ATTAINMENT_TREE.EDIT_GROUPING_MODULE_NAME</span>
        </button>
        <sis-button (clicked)="remove()" [link]="true" dataCy="hide-grouping-module">
          <sis-icon icon="close"></sis-icon>
          <span translate>ATTAINMENTS.EDITABLE_ATTAINMENT_TREE.HIDE_GROUPING_MODULE</span>
        </sis-button>
      }
    }
    @if (nameEditMode) {
      <div class="form-in-edit">
        <form>
          <sis-localized-string-editor
            [selectedLocale]="privateSelectedLocale"
            [editorFormGroup]="newName"
            data-cy="group-node-name-editor"
            class="hidden-translation-balls">
          </sis-localized-string-editor>
        </form>
        <button (click)="saveName()" type="button" class="link-button save-name" data-cy="save-group-node-name">
          <span translate>ATTAINMENTS.EDITABLE_ATTAINMENT_TREE.SAVE_GROUPING_MODULE_NAME</span>
        </button>
      </div>
    }
  </div>
</div>
@if (!!moduleContent) {
  <sis-editable-attainment-tree-study-selections
    [hidden]="collapsedByGroupingModuleId[moduleSelection.moduleId]"
    [moduleSelection]="moduleSelection"
    [indexedAttainments]="indexedAttainments"
    [courseUnitsById]="courseUnitsById"
    [modulesById]="modulesById"
    [moduleContent]="moduleContent"
    [selectedLocale]="selectedLocale"
    (childrenUpdated)="childrenUpdated.emit()"
    [collapsedByGroupingModuleId]="collapsedByGroupingModuleId"
    [groupingModuleVisibilityToggled]="mergedGroupingModuleVisibilityToggled"
    [class.grouping-node-removed]="moduleSelection.hidden">
  </sis-editable-attainment-tree-study-selections>
}
